export default function(data) {
var __t, __p = '';
__p += '<h2 class="modal-title">Forgot your password?</h2>\n<div class="row">\n  <div class="col large-8 medium-8 small-10 large-push-2 medium-push-2 small-push-1">\n    <p class="modal-description">\n      No problem, enter your email address below and we will send you a link to reset your password.\n    </p>\n    <div id=\'reset-password\'></div>\n  </div>\n</div>\n<br/>\n';
return __p
}